import React from "react";
import Box from "@mui/material/Box";
import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import { Helmet } from "react-helmet";
import { TabsWrapper } from "assets/styles/globalStyledComponent";
import { Container } from "@mui/material";
import WhatsAppPurpose from "./WhatsAppPurpose/WhatsAppPurpose";
import Configuration from "./Configuration/Configuration";

const WhatsAppSetting = () => {
  const [value, setValue] = React.useState("1");

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  return (
    <Container maxWidth="2xl" sx={{ mt: 2 }}>
      <Helmet>
        <title>WhatsApp Settings</title>
      </Helmet>
      <TabContext value={value}>
        <TabsWrapper>
          <TabList onChange={handleChange}>
            <Tab label="WhatsApp Purpose" value="1" />
            <Tab label="Configuration" value="2" />
          </TabList>
        </TabsWrapper>
        <TabPanel value="1" sx={{ p: "0 !important" }}>
          <Box sx={{ my: 2 }}>
            <WhatsAppPurpose />
          </Box>
        </TabPanel>
        <TabPanel value="2" sx={{ p: "0 !important" }}>
          <Box sx={{ my: 2 }}>
            <Configuration />
          </Box>
        </TabPanel>
      </TabContext>
    </Container>
  );
};

export default WhatsAppSetting;
